import React, { ReactNode } from "react";
import Section from "../../layout/Section/Section";
import Container from "../../layout/Container/Container";
import TextTitle from "../../base/Text/TextTitle/TextTitle";
import Spacer from "../../layout/Spacer/Spacer";
import HorizontalIconTextList from "../../feature/HorizontalIconTextList/HorizontalIconTextList";
import Button from "../../base/Button/Button";
import { legacySizeCollectionMap } from "../../base/Text/Text.map";
import Text from "../../base/Text/Text";
import { IconSvg } from "../../base/Icon/Icon.map";

export interface ISectionOurPromiseItem {
  icon: IconSvg;
  title: string;
  body: string | ReactNode;
}

export interface ISectionOurPromise {
  title?: string;
  items?: ISectionOurPromiseItem[];
  ctaText?: string;
  ctaHref?: string;
}

const DEFAULT_TITLE = "Our Promise To You";

const DEFAULT_ITEMS: ISectionOurPromiseItem[] = [
  {
    icon: "catBenefitShinyCoat",
    title: "Health benefits you can see",
    body: "95% of cat people say their cat is happier and healthier after switching to KatKin.",
  },
  {
    icon: "padlockUnlocked",
    title: "Manage your deliveries with complete flexibility",
    body: "Change your mix of recipes easily, or cancel altogether - and no surprise charges, ever.",
  },
  {
    icon: "phone",
    title: "Customer love guaranteed",
    body: <>Get answers, advice and even speak to a vet.
      Call us 7 days a week on <a href="tel:02045384144">0204 538 4144</a> or
      email <a href="mailto:meow@katkin.com">meow@katkin.com</a></>,
  },
];

const DEFAULT_CTA_TEXT = "Build their starter box";
const DEFAULT_CTA_HREF = "/sign-up/fresh?discount_code=FEAST20";

const SectionOurPromise = ({
  title = DEFAULT_TITLE,
  items = DEFAULT_ITEMS,
  ctaText = DEFAULT_CTA_TEXT,
  ctaHref = DEFAULT_CTA_HREF,
}: ISectionOurPromise = {}) => (
  <Section component={SectionOurPromise.name} theme="light" size="none">
    <Container>
      <div className="mb-4 md:mb-8 relative px-2">
        <Text tag={"h2"} display="title" size={legacySizeCollectionMap.titleLg} align="center"
          className="hidden md:block">{ title }</Text>
        <TextTitle size={1} align="center" className="block md:hidden">{ title }</TextTitle>
      </div>
      <Spacer size="lg" />
      <HorizontalIconTextList
        listTag="ul"
        items={items}
      />

      <Spacer size="lg" />
      <div className="md:flex md:justify-center">
        <Button
          to={ctaHref}
          className="md:!w-auto"
        >
          { ctaText }
        </Button>
      </div>
    </Container>
  </Section>
);

export default SectionOurPromise;
